import { Extension } from '@tiptap/core';

export const HardBreakOnEnter = Extension.create({
  addKeyboardShortcuts() {
    return {
      Enter: () => {
        return this.editor.commands.setHardBreak();
      },
    };
  },
});
